import { useState, useCallback } from 'react'
import { ModalDelete } from '../../../../../../baseComponents/Modal'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { InputNumberWithLabelMargin } from '../../../../../../forms/Input'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { WorkSheetProductStatusURLs } from '../../WorkSheetProductStatusFlow/WorkSheetProductStatusFlowInner/types'
import ITHeaderText from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { changeErrorMessage, changeSuccessMessage } from '../../../../../../utils/reducers/reduxDispatch'
import CustomError from '../../../../../../baseComponents/CustomError'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'

interface ModalChangeQuantityWorkSheetProductProps extends ModalChangeQuantityWorkSheetProductLogicProps { }

const ModalChangeQuantityWorkSheetProduct: React.FC<ModalChangeQuantityWorkSheetProductProps> = ({ allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { setQuantity, quantity, handleUpdateQuantity } = useModalChangeQuantityWorkSheetProductLogic({ allRowData, ...rest })
    return (
        <ModalDelete opened={true} setOpened={() => rest.setOpenModal(null)} className='flex_height ' translations={{ buttonAccept: t('change', 'Cambiar') }} onAccept={handleUpdateQuantity} >
            <h2><TwinTrans transKey='changeQuantity'>Cambiar cantidad</TwinTrans></h2>
            <CustomError textError={t('willChangeTheQuantityInSellOrder', 'Al cambiar la cantidad, cambiará también en el pedido correspondiente')} className='mt-5 text-left' />
            <div className='flex flex-auto flex-col items-start my-15 mt-30'>
                <InputStatusProduct {...{ allRowData, setQuantity, quantity }} />
            </div>
        </ModalDelete>
    )
}

interface ModalChangeQuantityWorkSheetProductLogicProps {
    allRowData?: RowData
    workSheetProductStatusURLs?: WorkSheetProductStatusURLs
    setOpenModal: SetEditDeleteModalTy
    getData: () => Promise<void>
}

const useModalChangeQuantityWorkSheetProductLogic = ({ allRowData, setOpenModal, getData }: ModalChangeQuantityWorkSheetProductLogicProps) => {
    const { t } = useTwinTranslation()
    const succesMsg = t('changeQuantitySellOrder', 'Se ha cambiado la cantidad en el pedido relacionado')
    const errorMsg = t('cantChangeQuantity', 'No se han podido cambiar las cantidades')
    const [quantity, setQuantity] = useState<string>(allRowData?.quantity)
    const handleUpdateQuantity = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/sell/workSheet/workSheetProduct/handleChangeQuantityOrderProduct', { quantity, WorkSheetProductId: allRowData?.id, SellOrderProductId: allRowData?.SellOrderProductId})
        if (result) {
            changeSuccessMessage(succesMsg)
            setOpenModal(null)
            getData()
        } else {
            changeErrorMessage(errorMsg)
        }
        return result
    }, [allRowData, quantity, setOpenModal, getData, succesMsg, errorMsg])

    return { setQuantity, quantity, handleUpdateQuantity }
}

interface InputStatusProductProps extends InputStatusProductLogicProps {
    quantity: string
}

const InputStatusProduct: React.FC<InputStatusProductProps> = ({ allRowData, setQuantity, quantity }) => {
    const { t } = useTwinTranslation()
    const { onBlur } = useInputStatusProductLogic({ allRowData, setQuantity })
    return (
        <div className='flex justify-start items-center w-full mb-14'>
            <InputNumberWithLabelMargin className={'mt-auto text-left'} label={t('quantity', 'Cantidad')} value={String(quantity)} onChange={setQuantity} onBlur={onBlur} />
            <div className={'w-full ml-40 text-left pb-9'}>
                <ITHeaderText className={'mt-auto '} label={t('desiredQuantity', 'Cantidad deseada')} value={String(allRowData?.desiredQuantity)} />
            </div>
        </div>
    )
}

interface InputStatusProductLogicProps {
    allRowData?: RowData
    setQuantity: React.Dispatch<React.SetStateAction<string>>
}

const useInputStatusProductLogic = ({ allRowData, setQuantity }: InputStatusProductLogicProps) => {
    const onBlur = useCallback((e: any) => {
        const value = e.currentTarget.value
        if (!value || !parseFloat(value)) {
            setQuantity(allRowData?.quantity)
        }
    }, [allRowData?.quantity, setQuantity])

    return { onBlur }
}

export default ModalChangeQuantityWorkSheetProduct